import React from "react";
import { Card, CardBody, Badge, Button } from "reactstrap";
import PropTypes from "prop-types";
import { ContentLoader } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";
import { GLOBAL_STATUS_LABELS } from "../../../../constants/common";;

const AcquirerSidebar = ({ acquirers, activeId, onSelect, onCreateNew, loading }) => {
    return (
        <Card className="border-0 shadow-sm h-100 overflow-hidden d-flex flex-column rounded-0">
            <div className="bg-white p-3 border-bottom sticky-top" style={{ zIndex: 10 }}>
                <div className="d-flex align-items-start mb-3">
                    <i className="mdi mdi-credit-card-settings text-primary font-size-22 me-2 mt-1"></i>
                    <div className="ms-2">
                        <h6 className="mb-0 fw-bold">Adquirentes</h6>
                        <small className="text-muted">Taxas e Bandeiras</small>
                    </div>
                </div>

                <Button
                    color="primary"
                    className="w-100 border-0 fw-bold shadow-sm rounded-0 py-2 d-flex align-items-center justify-content-center text-white"
                    onClick={onCreateNew}
                >
                    <i className="mdi mdi-plus-circle-outline font-size-16 me-2"></i>
                    Nova Adquirente
                </Button>
            </div>

            <div className="flex-grow-1 overflow-auto bg-light-subtle p-2">
                {loading && acquirers.length === 0 ? (
                    <div className="py-5">
                        <ContentLoader message="Carregando adquirentes..." />
                    </div>
                ) : acquirers.length === 0 ? (
                    <div className="text-center p-4">
                        <i className="mdi mdi-credit-card-off-outline font-size-32 text-muted mb-3"></i>
                        <p className="text-muted font-size-13">Nenhuma adquirente cadastrada.</p>
                    </div>
                ) : (
                    <div className="d-flex flex-column gap-2">
                        {acquirers.map((acq) => (
                            <div
                                key={acq.id}
                                className={`card mb-0 cursor-pointer border rounded-0 transition-all ${activeId === acq.id ? 'border-primary shadow-sm' : 'border-light shadow-none hover-border-primary'}`}
                                onClick={() => onSelect(acq)}
                                style={{
                                    backgroundColor: activeId === acq.id ? '#f3f8ff' : '#fff'
                                }}
                            >
                                <CardBody className="p-3">
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div className="overflow-hidden">
                                            <h6 className="font-size-14 fw-bold mb-1 text-dark text-truncate">
                                                {acq.name}
                                            </h6>
                                            <div className="d-flex gap-1 flex-wrap mt-2">
                                                {acq.rates && Object.keys(acq.rates).slice(0, 4).map(flag => (
                                                    <Badge key={flag} color="light" className="text-muted border">
                                                        {flag.toUpperCase()}
                                                    </Badge>
                                                ))}
                                                {acq.rates && Object.keys(acq.rates).length > 4 && (
                                                    <Badge color="light" className="text-muted border">
                                                        +{Object.keys(acq.rates).length - 4}
                                                    </Badge>
                                                )}
                                            </div>
                                        </div>
                                        <Badge color={acq.status === GLOBAL_STATUS.ACTIVE ? "soft-success" : "soft-danger"}>
                                            {GLOBAL_STATUS_LABELS[acq.status] || 'Desconhecido'}
                                        </Badge>
                                    </div>
                                </CardBody>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </Card>
    );
};

AcquirerSidebar.propTypes = {
    acquirers: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default AcquirerSidebar;
